







import { LoginBaseOnMobileToken } from '@/modules/auth/interfaces/loginBaseOnMobileToken';
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

@Component({
  components: {
  },
})
export default class RedirectFromMobile extends Vue {
    public path?: string;
    public token?: string;

    @Action('auth/loginBaseOnMobileToken')
    private loginBaseOnMobileToken!: (request: LoginBaseOnMobileToken) => Promise<boolean | undefined>;

    constructor() {
        super();
    }

    public async created() {
        this.path = this.$route.query.path ? this.$route.query.path as string : undefined;

        if (this.path == null){
            this.$router.push("/");
            return;
        }

        this.token = this.$route.query.token ? this.$route.query.token as string : undefined;

        if (this.token == null){
            this.$router.push("/");
            return;
        }

        const success = await this.loginBaseOnMobileToken({
            token: this.token
        });

        if (success) {            
            setTimeout(() => this.$router.push(this.path ? this.path : "/"), 3000);
        }else {
            this.$router.push("/");
            return;
        }
    }
}
